import React, { useState, useEffect } from 'react';
import axios from 'axios';
import DatePicker from 'react-datepicker';
import { ru } from 'date-fns/locale';

import 'react-datepicker/dist/react-datepicker.css';
import './AddEvents.css';
import eventsPhoto from './../../images/events-main-photo.jpg';
import editIcon from './../../images/events-name-edit.svg';
import searchLocation from './../../images/location-search.svg';
import locationIcon from './../../images/search.png';
import calendarIcon from './../../images/calendar.svg';

const AddEvents = ({
    setCurrentPage,
    newEventAddress,
    newEventCategory,
    newEventDate,
    setNewEventDate,
    newEventCoords,
    setNewEventCategory,
    setNewEventCoords,
    setNewEventAddress,
    newEventDescription,
    setNewEventDescription,
    newEventCount,
    setNewEventCount,
    translations,
    userLang,
    newRecommendId,
    setNewRecommendId,
    isFullScreenMode,
}) => {
    const [isDatePickerOpen, setIsDatePickerOpen] = useState(false);
    const [isDateSelected, setIsDateSelected] = useState(false);
    const currentDate = new Date();

    useEffect(() => {
        console.log('newEventCoords: ', newEventCoords);
        console.log('newEventAddress: ', newEventAddress);
    }, [newEventCoords, newEventAddress]);

    const handleNewLocationClick = () => {
        if (newEventCategory) {
            setCurrentPage('RecommendPage');
        } else {
            alert('Выберите категорию мероприятия');
        }
    };

    const handleNewCategoryClick = () => {
        setCurrentPage('NewTypeEvents');
    };

    const handleNewDateClick = () => {
        setIsDatePickerOpen(true);
    };

    const handleDateChange = (date) => {
        setNewEventDate(date);
        setIsDateSelected(true);

        if (date && date.getTime() !== currentDate.getTime()) {
            setIsDatePickerOpen(false);
        }
    };

    const handleDatePickerClose = () => {
        if (isDateSelected) {
            setIsDatePickerOpen(false);
        }
    };

    const handleEventCountChange = (event) => {
        setNewEventCount(event.target.value);
    };

    const formatEventDate = (date) => {
        const formattedDate = date.toLocaleString('ru-RU', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
        });
        return formattedDate;
    };

    useEffect(() => {
        const valueRange = document.querySelector('.member__range');
        const percentage = ((newEventCount - 2) / (10 - 2)) * 100;
        valueRange.style.setProperty('--value', `${percentage}%`);
    }, [newEventCount]);

    // запрос на создание мероприятия
    const handleCreateEvent = async () => {
        if (
            newEventDescription &&
            newEventCategory &&
            newEventAddress &&
            newEventDate
        ) {
            const eventData = {
                eventSubCategoryId: newEventCategory.id,
                description: newEventDescription,
                count: newEventCount,
                start: newEventDate.toISOString(),
                city: newEventAddress.split(',')[0].trim(),
                latitude: newRecommendId ? null : newEventCoords[0],
                longitude: newRecommendId ? null : newEventCoords[1],
                address: newRecommendId ? null : newEventAddress,
                adId: newRecommendId,
            };

            try {
                const response = await axios.post(
                    'https://mepointserver.ru/event/create',
                    eventData,
                    {
                        headers: {
                            Authorization: `Bearer ${localStorage.getItem(
                                'authToken'
                            )}`,
                        },
                    }
                );
                console.log('Мероприятие создано! ', response.data);
                console.log('city ', newEventAddress.split(',')[0].trim());
                setCurrentPage('MapPage');
                setNewEventDescription(null); // удаление описания
                setNewEventCategory(null); // удаление выбранной категории
                setNewEventDate(null); // удаление выбранной даты
                setNewEventCoords(null); // удаление выбранных координат
                setNewEventAddress(null); // удаление выбранного адреса
                setNewEventCount(2); // удаление количества игроков
                setNewRecommendId(null); // удаление рекомендации (если была выбрана)
            } catch (error) {
                console.error('Ошибка при создании мероприятия ', error);

                if (error.response.data.error.message === 'LimitOwnerEvents') {
                    alert(translations.limitOwnerEvents);
                }
            }
        }
    };

    return (
        <div className='add__events'>
            <div
                className={
                    isFullScreenMode
                        ? 'add__events_container_full'
                        : 'add__events_container'
                }
            >
                <div
                    className={
                        isFullScreenMode
                            ? 'add__events_title_full'
                            : 'add__events_title'
                    }
                >
                    <h1>{translations.createEvent}</h1>
                </div>
                <div className='add__events_wrapper'>
                    <div className='add__events_items'>
                        <div
                            className='events__name'
                            onClick={handleNewCategoryClick}
                        >
                            <img
                                className='events__main_photo'
                                src={
                                    newEventCategory
                                        ? 'https://mepointserver.ru' +
                                          newEventCategory.imageLink
                                        : eventsPhoto
                                }
                                alt='events'
                            />
                            <h3 className='events__title'>
                                {newEventCategory
                                    ? newEventCategory.name
                                    : `${translations.selectCategory}`}
                            </h3>
                            <img
                                className='events__title_edit'
                                src={editIcon}
                                alt='edit'
                            />
                        </div>
                        <div className='events__description'>
                            <h5>{translations.description}</h5>
                            <textarea
                                maxLength={255}
                                value={newEventDescription}
                                onChange={(e) =>
                                    setNewEventDescription(e.target.value)
                                }
                                placeholder={translations.shortDescription}
                            ></textarea>
                        </div>
                        <div className='events__members'>
                            <h5>
                                {translations.members}:{' '}
                                {newEventCount == 2 && <span>2</span>}
                                {newEventCount == 3 && <span>3</span>}
                                {newEventCount == 4 && <span>4</span>}
                                {newEventCount == 5 && <span>5</span>}
                                {newEventCount == 6 && <span>6</span>}
                                {newEventCount == 7 && <span>7</span>}
                                {newEventCount == 8 && <span>8</span>}
                                {newEventCount == 9 && <span>9</span>}
                                {newEventCount == 10 && <span>10</span>}
                            </h5>

                            <input
                                className='member__range'
                                type='range'
                                min='2'
                                max='10'
                                step='1'
                                value={newEventCount}
                                onChange={handleEventCountChange}
                            />
                            <div className='member__labels'>
                                <span>2</span>
                                <span>10</span>
                            </div>
                        </div>
                        <div className='events__data'>
                            <h5>{translations.date}</h5>
                            <div
                                className={`input__data ${
                                    newEventDate ? 'active' : ''
                                }`}
                                onClick={handleNewDateClick}
                            >
                                <p>
                                    {newEventDate
                                        ? formatEventDate(newEventDate)
                                        : formatEventDate(currentDate)}
                                </p>
                                <img
                                    className='calendar__icon'
                                    src={calendarIcon}
                                />
                            </div>
                        </div>
                        {isDatePickerOpen && (
                            <DatePicker
                                selected={newEventDate || currentDate}
                                onChange={handleDateChange}
                                onClickOutside={handleDatePickerClose}
                                showTimeSelect
                                timeFormat='HH:mm'
                                timeIntervals={15}
                                dateFormat='dd.MM.yyyy HH:mm'
                                locale={userLang === 'ru-RU' ? ru : undefined}
                                minDate={currentDate}
                                inline
                            />
                        )}
                        <div className='events__location'>
                            <h5>{translations.location}</h5>

                            <div
                                className={`input__location ${
                                    newEventAddress ? 'active' : ''
                                }`}
                                onClick={handleNewLocationClick}
                            >
                                <img
                                    className='search__icon'
                                    src={searchLocation}
                                />
                                <p>
                                    {newEventAddress
                                        ? newEventAddress
                                        : `${translations.selectLocation}`}
                                </p>
                                <img
                                    className='location__icon'
                                    src={locationIcon}
                                />
                            </div>
                        </div>
                        <div
                            className={`events__button ${
                                newEventDescription &&
                                newEventCategory &&
                                newEventAddress &&
                                newEventDate
                                    ? 'active'
                                    : ''
                            }`}
                        >
                            <button onClick={handleCreateEvent}>
                                {translations.create}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AddEvents;
